export default __webpack_public_path__ + "static/media/wi_2.7a3a38e2.mp3";